import React from 'react';
import { clientOnly } from './clientOnly';
import type { Props as ReactModalProps } from 'react-modal';

const ReactModal = clientOnly(async () => {
    const { default: Modal } = await import('react-modal');
    // Render the class directly so React retains its defaults during unmount.
    return { default: (props: ReactModalProps) => <Modal {...props} /> };
});

/**
 * react-modal, loaded only in the browser the first time a modal opens.
 * react-modal renders nothing while closed (and nothing on the server), so
 * skipping it until `isOpen` keeps the markup identical.
 */
const LazyModal: React.FC<ReactModalProps> = (props) => {
    if (!props.isOpen) return null;

    const appElement =
        props.appElement ??
        (props.ariaHideApp === false || typeof document === 'undefined'
            ? undefined
            : document.getElementById('___gatsby') || document.body);

    return <ReactModal {...props} appElement={appElement} />;
};

/** Fetches react-modal ahead of time, for modals that must open instantly. */
export const preloadModal = () => {
    ReactModal.load();
};

export default LazyModal;
